import { FoodsIconButton } from "@foodpilot/foods";
import { Stack, Typography, useTheme } from "@mui/material";
import { Link } from "react-router";
import { useQuestionnaireFormContext } from "src/components/QuestionnaireForm/context/useQuestionnaireForm";

export const LeftName = () => {
    const { ssqVersion, title, subtitle, backUrl } = useQuestionnaireFormContext();

    const ssqTitle = typeof title === "function" ? title(ssqVersion?.ssq) : title;
    const ssqSubtitle = typeof subtitle === "function" ? subtitle(ssqVersion?.ssq) : subtitle;

    const theme = useTheme();
    return (
        <Stack flexDirection={"row"} gap={theme.spacing(1)} alignItems={"center"}>
            <Link to={backUrl}>
                <FoodsIconButton size={"m"} icon={"arrowLeft"} />
            </Link>
            <Stack width={"100%"}>
                <Typography variant="h3">{ssqTitle}</Typography>
                <Typography variant="small-medium" sx={{ color: theme.custom.grey[1400] }}>
                    {ssqSubtitle}
                </Typography>
            </Stack>
        </Stack>
    );
};
